// Onderdeel 5 (2026-07-27, Laag-fix — Opus-review, prioritair behandeld):
// centrale escape-helper voor vrije tekst die in mail-HTML terechtkomt.
// Zie supabase/functions/_shared/escapeHtml.ts voor het Deno-equivalent —
// dezelfde logica, bewust niet gedeeld tussen de twee runtimes.
export function escapeHtml(value) {
  if (value === null || value === undefined) return '';
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}
